import Headline from '../../components/Headline';
import Menu from '../../components/Menu';
import Timer from './Timer';
import Action from '../Main/Details/Action';
import { useLocation, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectProduct } from '../../../../../store/selectors/products';

const Permissions = () => {
  let { product } = useParams();
  const { data } = useSelector(selectProduct);
  const { isActive } = data;

  const { search } = useLocation();
  const useQuery = () => new URLSearchParams(search);
  const query = useQuery();
  const Product = query.get('product');

  return (
    <div className='integration__permissions'>
      {!isActive && <Action />}

      <Headline message='Integration permissions headline' />

      <Menu
        items={[
          {
            labeli18n: 'Test environment',
            url: `/integrations/${product}/permissions/testing?product=${Product}`,
            isActive: isActive,
          },
          {
            labeli18n: 'Production environment',
            url: `/integrations/${product}/permissions/production?product=${Product}`,
            isActive: isActive,
          },
        ]}
      />

      <Timer />
    </div>
  );
};

export default Permissions;
